<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">
          <Input
            clearable
            placeholder="输入关键字搜索"
            class="search-input"
            v-model="keyword"
          />
          <label class="search-label" >平台</label>
          <Select v-model="live" class="search-input" clearable> 
            <Option
              v-for="item in liveIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Button @click="handleSearch" class="search-btn"type="primary"
            >搜索</Button>
            <Button @click="showAddModal" type="primary" style="margin-left: 20px;">添加目标客户</Button>
            <Button @click="showAddUser" type="primary" style="margin-left: 20px;">添加运营账号</Button>
        </Col>
      </Row>

      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="添加客户账号"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
        ref="addUser"  
       @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="addWxChat"
      title="选择企业微信管理者"
      footer-hide
      >
      <forms_ :resetFlag="resetFlag"
        ref="addWechat"  
       @on-ok="addWechatSumit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="editMaxCount"
      title="编辑最大数量"
      footer-hide
      >
      <Forms_edit :resetFlag="resetFlag"
        ref="editMaxCount"  
       @on-ok="editMaxCountEmit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="showAddUserModal"
      title="添加运营账号"
      footer-hide
      >
      <Forms_user :resetFlag="resetFlag"
        ref="addStrategyUser"  
       @on-ok="addStrategyUserEmit" @on-cancel="cancel" />
    </Modal>

    <Modal
      :mask-closable="false"
      v-model="showEditUserModal"
      title="编辑运营账号"
      footer-hide
      >
      <Forms_user :resetFlag="resetFlag"
        ref="editStrategyUser"  
       @on-ok="editStrategyUserEmit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Forms from "./add_users_form.vue";
import Forms_ from "./add_wx_chat_form.vue";
import Forms_edit from "./edit_max_count_form.vue";
import Forms_user from "./add_strategy_user_form.vue";
import Forms_stand_user from "./add_stand_user_form.vue";
import Tables from "_c/tables/table-only.vue";

import { getStrategyUser, getClassifys, addUserExcel, editUserBlack, getLiveType, 
  getWxContacts, editUserWechat, editUserMaxCount, getShortVideoClassify, addDyUser, getShortVideoWorkTypeList, addStrateUser, editStrategyUser, deleteDyUser} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms,
    Forms_,
    Forms_edit,
    Forms_user,
    Forms_stand_user
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      addWxChat:false,
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      editMaxCount: false,
      showAddUserModal:false,
      showEditStandUserModal:false,
      showEditUserModal:false,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      wxContacts:[],
      live:"",
      user:'',
      keyword:'',
      userIds:[],
      liveIds:[],
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "用户名" , key: "username", editable: true, align: "center"},
        { title: "个人简介" , key: "user_desc", editable: true, align: "center"},
        // { title: "个人简介" , key: "user_desc", editable: true,  align: "center",
        //   render: (h, params) => {
        //       return h('div', [
        //       // 显示的位置上方
        //         h('Tooltip', {
        //           props: { placement: 'top' ,transfer: true}
        //         }, [
        //           h('span', {
        //             style: {
        //               display: 'inline-block',
        //               width: '70px',
        //               overflow: 'hidden',
        //               textOverflow: 'ellipsis',
        //               whiteSpace: 'nowrap',
        //             },
        //           }, params.row.user_desc),
        //           // 显示的内容
        //           h('span', {
        //             slot: 'content',
        //             style: { whiteSpace: 'normal', wordBreak: 'break-all' }
        //           },params.row.user_desc)
        //         ])
        //       ])
        //     }
        // },
        { title: "视频分类" , key: "video_classify", editable: true, align: "center"},
        // { title: "工作类型" , key: "short_video_work", editable: true, align: "center"},
        { title: "语言" , key: "language", editable: true, align: "center"},
        { title: "所属产品" , key: "classify", editable: true, align: "center"},
        { title: "所属平台" , key: "live", editable: true, align: "center"},
        // { title: "位置信息" , key: "location", editable: true, align: "center"},
        // { title: "运行状态" , key: "status", editable: true, align: "center"},
        { title: "主页链接" , key: "home_url",  editable: true,
        render: (h, params) => {
            return params.row.home_url != '' ? h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.download(params.row.home_url);
                    },
                  },
                },
                "查看"
              )
            ]) : h('span', '');
          }},
        // { title: "企业微信管理者" , key: "wechat", editable: true, align: "center" },
         {
          title: "是否禁用",
          key: "_black",
          width: 100, align: "center",
          render: (h, params) => {
            return h("div", [
              h("i-switch", {
                props: {
                  type: "primary",
                  value: params.row._black === true,
                },
                style: {
                  marginRight: "5px",
                },
                on: {
                  "on-change": (value) => {
                    this.changeUserStatus(value, params);
                  },
                },
              }),
            ]);
          },
        },
        // { title: "今天点赞数" , key: "like_count_today", editable: true, align: "center" },
        // { title: "今天评论数" , key: "comment_count_today", editable: true, align: "center", sortable: true},
        // { title: "当天最大评论数" , key: "day_max_comment", width: 100, editable: true, align: "center", sortable: true},
        // { title: "当天最大点赞数" , key: "day_max_like", width: 100, editable: true, align: "center", sortable: true },
        // { title: "当天最大关注数" , key: "day_max_follower", width: 100, editable: true, align: "center", sortable: true },
        // { title: "当天最大主动私信数" , key: "day_max_letter", width: 100, editable: true, align: "center", sortable: true },
        // { title: "当天最大主动私信数" , key: "day_max_search", width: 100, editable: true, align: "center", sortable: true },
        {
          title: "Handle",
          key: "handle", align: "center",
          render: (h, params) => {
            return h("div", [              
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "success",
              //       size: "small",
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.standUser(params);
              //       },
              //     },
              //   },
              //   "对标账号"
              // ),
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.flower(params);
                    },
                  },
                },
                "客户列表"
              ),
              // h(
              //   "Button",
              //   {
              //     props: {
              //       type: "success",
              //       size: "small",
              //     },
              //     style: {
              //       marginRight: "5px",
              //     },
              //     on: {
              //       click: () => {
              //         this.wechat(params);
              //       },
              //     },
              //   },
              //   "企业微信管理人"
              // ),            
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.userFaceLibrary(params);
                    },
                  },
                },
                "人脸库"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.letter(params);
                    },
                  },
                },
                "私信记录"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.editMaxCountMethod(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.delete(params);
                    },
                  },
                },
                "删除"
              )
            ]);
          },
        }

  
      ],
      tableData: [],
    };
  },
  methods: {
    download(url) {
      window.open(url, '_blank');
    },
    editStandUserEmit(){

    },
    standUser(params){
      // this.showEditStandUserModal = true
      // this.$refs.editStrategyUser.setEditData(params.row.id)
      this.$router.push({ name: "stand_user", query: { id: params.row.id}});
    },
    userFaceLibrary(params){
      this.$router.push({ name: "userFaceLibrary", query: { id: params.row.id}});
    },
    showAddUser(){
      this.resetFlag = !this.resetFlag;
      this.showAddUserModal = true
      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.addStrategyUser.setLiveType(liveTypes);
      });
    
      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addStrategyUser.setClassifyData(classifyIds);
      });

      getShortVideoWorkTypeList().then((res) => {
        var workType = res.data.data.records;
        this.$refs.addStrategyUser.setShortVideoWorkTypeData(workType);
      });

      getShortVideoClassify().then((res) => {
        var workType = res.data.data.records;
        this.$refs.addStrategyUser.setVideoClassify(workType);
      });

    },
    editStrategyUserEmit(params){
      const data = {
          username: params.username,
          dy_classify_id: params.classify_id,
          user_desc: params.desc,
          live_id: params.live_id,
          video_classify_id: params.video_classify_id,
          home_url: params.home_url,
          work_type_id: params.work_type_id,
          day_max_like:params.day_max_like_count,
          day_max_comment:params.day_max_comment_count,
          day_max_follower:params.day_max_follower_count,
          day_max_letter:params.day_max_letter_count,
          day_max_search:params.day_max_search_count,
          video_classify:params.video_classify_id,
          language:params.language,
          video_model_url: JSON.stringify(params.uploadList),
          keywords: params.keywords.length > 0 ? JSON.stringify(params.keywords): null,
          push_video_type: params.push_video_type,
          reversal: params.reversal == '是',
          stretch: params.stretch == '是'
        }
        editStrategyUser(data, params.id)
          .then((res) => {
            if (res.data.code == 200) {
              this.$Message.success("成功!");
              this.showEditUserModal = false;
              this.handleSearch();
            } else {
              this.$Message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.$Message.error("失败!");
          });
    },
    addStrategyUserEmit(params){
      if (params.type == '手动添加'){
          const data = {
            username: params.username,
            dy_classify_id: params.classify_id,
            user_desc: params.desc,
            live_id: params.live_id,
            video_classify_id: params.video_classify_id,
            home_url: params.home_url,
            work_type_id: params.work_type_id,
            language:params.language,
            video_model_url: JSON.stringify(params.uploadList),
            keywords: params.keywords.length > 0 ? JSON.stringify(params.keywords): null
          }
        addStrateUser(data)
          .then((res) => {
            if (res.data.code == 200) {
              this.$Message.success("成功!");
              this.showAddUserModal = false;
              this.handleSearch();
            } else {
              this.$Message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.$Message.error("失败!");
          });

      }else{
        let data = new FormData();
        data.set("path",  params.filePath);
        addDyUser(data)
          .then((res) => {
            if (res.data.code == 200) {
              this.$Message.success("成功!");
              this.showAddUserModal = false;
              this.handleSearch();
            } else {
              this.$Message.error(res.data.msg);
            }
          })
          .catch((err) => {
            this.$Message.error("失败!");
          });
      }

    },
    editMaxCountMethod(params){
      this.showEditUserModal = true
      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.editStrategyUser.setLiveType(liveTypes);
      });
    
      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.editStrategyUser.setClassifyData(classifyIds);
      });

      getShortVideoWorkTypeList().then((res) => {
        var workType = res.data.data.records;
        this.$refs.editStrategyUser.setShortVideoWorkTypeData(workType);
      });

      getShortVideoClassify().then((res) => {
        var workType = res.data.data.records;
        this.$refs.editStrategyUser.setVideoClassify(workType);
        this.$refs.editStrategyUser.setEditData(params.row);
      });
    },
    wechat(params){
      this.addWxChat = true
      this.resetFlag = !this.resetFlag;
      getWxContacts().then((res) => {
        this.wxContacts = res.data.data;
        this.$refs.addWechat.setWxContacts(this.wxContacts);
        this.$refs.addWechat.setEditData(params.row);
      });
    },
    changeUserStatus(value, params) {
      let data = new FormData();
      data.append("black", value);
      editUserBlack(data, params.row.id).then((res) => {
        if (res.data.code == 200) {
          this.$Message.success("成功!");
        } else {
          this.$Message.error(res.data.msg);
        }
      });
    },
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
      
      getLiveType().then((res) => {
        var liveTypes = res.data.data;
        this.$refs.addUser.setLiveType(liveTypes);
      });

      getClassifys().then((res) => {
        var classifyIds = res.data.data.records;
        this.$refs.addUser.setClassifyData(classifyIds);
      });
    },
    flower(params) {
      this.$router.push({ name: "flower", query: { id: params.row.id, classify_id :params.row.dy_classify_id, live_id: params.row.live_id}});
    },letter(params){
      this.$router.push({ name: "letter", query: { id: params.row.dy_id, classify_id :params.row.dy_classify_id}});
    },
    addWechatSumit(formValidate){
      let data = new FormData();
      data.set("wechat_id", formValidate.constacts);
      var wechat = ''
      for (var i = 0; i < this.wxContacts.length; i++){
        if (formValidate.constacts == this.wxContacts[i]['userid']){
          wechat = this.wxContacts[i]['name']
          break
        }
      }
      data.set("wechat_name", wechat);
      editUserWechat(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addWxChat = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },editMaxCountEmit(formValidate){
      let data = new FormData();
      data.set("day_max_like", formValidate.day_max_like_count);
      data.set("day_max_comment", formValidate.day_max_comment_count);
      data.set("day_max_follower", formValidate.day_max_follower_count);
      data.set("day_max_letter", formValidate.day_max_letter_count);
      data.set("day_max_search", formValidate.day_max_search_count);
      data.set("video_classify", formValidate.video_classify_id);
      editUserMaxCount(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editMaxCount = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });

    },
    addSumit(formValidate) {
      let data = new FormData();
      data.set("classify_id", formValidate.classify);
      data.set("path", formValidate.filePath);
      data.set("tag_id", formValidate.tag_id);
      data.set("live_id", formValidate.live_id);
      addUserExcel(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        live_id:this.live,
        keyword:this.keyword
      };
      getStrategyUser(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });

      getLiveType(params).then((res) => {
        if (res.data.code == 200) {
          var lives = res.data.data;
          var data = new Array()
          for (var i = 0; i < lives.length; i++) {
            data[i] = { id: lives[i].id.toString(), name: lives[i].name }
          }
          this.liveIds = data
          }
      });  
    },
    delete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              deleteDyUser(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>
